import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import Draggable from 'react-draggable';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';
import Tooltip from 'components/common/Tooltip';

import IconCross from 'components/icons/IconCross';
import IconButton from 'components/common/IconButton';
import IconMoveVert from 'components/icons/IconMoveVert';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  root: {
    padding: '0 30px 0 0',
    display: 'block',
    marginTop: 20,
  },
  listItemSecondaryAction: {
    top: 10,
    right: -15,
  },
  iconCross: {
    width: 11,
    height: 11,
  },
  buttonMove: {
    marginTop: -16,
    marginLeft: -16,
    position: 'relative',
    top: 1,
  },
  iconMoveVert: {
    width: 10,
    height: 16,
  },
  gridItemShrink: {
    flexShrink: 1,
  },
  draggable: {
    position: 'relative',
  },
  draggableDragged: {
    zIndex: 10,
  },
  draggableContentWithTransition: {
    backgroundColor: theme.palette.common.white,
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.short,
    }),
  },
  typographyExpire: {
    backgroundColor: theme.palette.validation[300],
  },
});

class OrderInformationDiagnosesField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dragged: false,
      position: null,
      bounds: null,
    };

    this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
    this.onDraggableDataChange = this.onDraggableDataChange.bind(this);
    this.onStartDrag = this.onStartDrag.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.onStopDrag = this.onStopDrag.bind(this);
  }

  componentDidMount() {
    this.draggableDataChangeTimeout = setTimeout(() => {
      this.onDraggableDataChange();
    }, 100);
  }

  componentDidUpdate(prevProps) {
    const { timestamp } = this.props;
    if (timestamp !== prevProps.timestamp) {
      this.draggableDataChangeTimeout = setTimeout(() => {
        this.onDraggableDataChange();
      }, 100);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.draggableDataChangeTimeout);
  }

  onDeleteButtonClick() {
    this.props.onRemove();
  }

  onDraggableDataChange() {
    const { boundsSelector, index, onDraggableDataChange } = this.props;
    if (boundsSelector) {
      const draggableRefDOMRect = this.draggableRef.getBoundingClientRect();
      const boundsDOMRect = document.querySelector(boundsSelector).getBoundingClientRect();
      const left = Math.round(boundsDOMRect.left - draggableRefDOMRect.left);
      const top = Math.round(boundsDOMRect.top - draggableRefDOMRect.top);
      const right = Math.round((boundsDOMRect.width - draggableRefDOMRect.width) + left);
      const bottom = Math.round((boundsDOMRect.height - draggableRefDOMRect.height) + top);
      const data = {
        bounds: { left, top, right, bottom },
        width: draggableRefDOMRect.width,
        height: draggableRefDOMRect.height,
      };
      const draggableData = {};
      draggableData[index] = data;
      this.setState(data);
      onDraggableDataChange(draggableData);
    }
  }

  onStartDrag(event, data) {
    const { onStartDrag, index } = this.props;
    const { bounds, width, height } = this.state;
    this.onDraggableDataChange();
    this.setState({ dragged: true });
    if (onStartDrag) {
      onStartDrag({
        x: data.x - bounds.left,
        y: data.y - bounds.top,
        width,
        height,
        defaultX: -bounds.left,
        defaultY: -bounds.top,
        index,
      });
    }
  }

  onDrag(event, data) {
    const { onDrag, index } = this.props;
    const { bounds, width, height } = this.state;
    if (onDrag) {
      onDrag({
        x: -bounds.left,
        y: data.y - bounds.top,
        width,
        height,
        defaultX: -bounds.left,
        defaultY: -bounds.top,
        index,
      });
    }
  }

  onStopDrag(event, data) {
    const { onStopDrag, index } = this.props;
    const { bounds, width, height } = this.state;
    this.setState({
      dragged: false,
      position: {
        x: 0,
        y: 0,
      },
    });
    if (onStopDrag) {
      onStopDrag({
        x: data.x - bounds.left,
        y: data.y - bounds.top,
        width,
        height,
        defaultX: -bounds.left,
        defaultY: -bounds.top,
        index,
      });
    }
  }

  render() {
    const {
      Diagnosis,
      input,
      pointer,
      dragDisabled,
      withTransition,
      offsetY,
      disabled,
      dateOfServiceTo,
      classes,
    } = this.props;
    const { bounds, position, dragged } = this.state;
    const diagnosesItem = Diagnosis.find(item => item.ID === input.value);
    if (!diagnosesItem) {
      return '';
    }
    return (
      <Draggable
        axis="y"
        handle={`.${classes.buttonMove}`}
        disabled={dragDisabled}
        {...bounds ? { bounds } : {}}
        {...position ? { position } : {}}
        onStart={this.onStartDrag}
        onDrag={this.onDrag}
        onStop={this.onStopDrag}
      >
        <div
          className={classNames(classes.draggable, {
            [classes.draggableDragged]: dragged,
          })}
          ref={(draggableRef) => {
            this.draggableRef = draggableRef;
          }}
        >
          <div
            className={classNames({
              [classes.draggableContentWithTransition]: withTransition,
            })}
            style={{ transform: `translateY(${offsetY}px)` }}
          >
            <ListItem
              className={classes.root}
              disableGutters
            >
              <Grid
                container
                spacing={0}
                wrap="nowrap"
                alignItems="flex-start"
              >
                <Grid item>
                  <IconButton
                    className={classes.buttonMove}
                    disabled={dragDisabled || disabled}
                    tooltipContent={(!dragDisabled && !dragged)
                      ? 'Drag it to Change Position' : null}
                  >
                    <IconMoveVert className={classes.iconMoveVert} />
                  </IconButton>
                </Grid>
                <Grid className={classes.gridItemShrink} item>
                  <Typography component="span" gutterBottom>
                    {pointer}
                    {': '}
                    {(diagnosesItem['Expire At'] && moment(diagnosesItem['Expire At'], dateFormat)
                      .isSameOrBefore(moment(dateOfServiceTo, dateFormat))) ? (     
                      <Tooltip
                        content={
                          <Typography>
                            Expired At: {diagnosesItem['Expire At']}
                          </Typography>
                        }
                        placement="top"
                      >
                        <Typography className={classes.typographyExpire}>
                          {diagnosesItem['DX Code']}
                        </Typography>
                      </Tooltip>
                    ) : diagnosesItem['DX Code']}        
                    {' '}
                    {diagnosesItem['Long Description']}
                  </Typography>
                  {diagnosesItem.create_at &&
                    <Typography
                      variant="caption"
                      component="span"
                    >
                      {diagnosesItem.create_at}
                    </Typography>
                  }
                </Grid>
              </Grid>
              <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
                <IconButton
                  aria-label="Remove"
                  onClick={this.onDeleteButtonClick}
                  tooltipContent="Remove"
                  disabled={disabled}
                >
                  <IconCross className={classes.iconCross} />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </div>
        </div>
      </Draggable>
    );
  }
}

OrderInformationDiagnosesField.propTypes = {
  pointer: PropTypes.string.isRequired,
  input: PropTypes.shape({
    value: PropTypes.number,
  }).isRequired,
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'DX Code': PropTypes.string.isRequired,
    'Long Description': PropTypes.string.isRequired,
    create_at: PropTypes.string,
  })).isRequired,
  onRemove: PropTypes.func,
  boundsSelector: PropTypes.string,
  dragDisabled: PropTypes.bool,
  onStartDrag: PropTypes.func,
  onDrag: PropTypes.func,
  onStopDrag: PropTypes.func,
  onDraggableDataChange: PropTypes.func,
  withTransition: PropTypes.bool,
  offsetY: PropTypes.number,
  timestamp: PropTypes.number,
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    listItemSecondaryAction: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
    buttonMove: PropTypes.string.isRequired,
    iconMoveVert: PropTypes.string.isRequired,
    gridItemShrink: PropTypes.string.isRequired,
    draggable: PropTypes.string.isRequired,
    draggableDragged: PropTypes.string.isRequired,
    draggableContentWithTransition: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationDiagnosesField.defaultProps = {
  onRemove: () => {},
  boundsSelector: null,
  dragDisabled: false,
  onStartDrag: null,
  onDrag: null,
  onStopDrag: null,
  offsetY: 0,
  withTransition: false,
  timestamp: 0,
  disabled: false,
  onDraggableDataChange: () => {},
};

export default withStyles(styles)(OrderInformationDiagnosesField);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationDiagnoses/OrderInformationDiagnosesField.js